usuario.component('usuario.dadosComponent', {
    templateUrl: 'usuario/dados/dados.html',
    controller: 'usuario.dadosController',
    bindings: { baseUsuario: '<' }
});

usuario.controller('usuario.dadosController', ['$scope', 'coreUtils', 'coreToast', 'coreFb', 'coreLanguage', function($scope, $utils, $toast, $fb, $text) {

    $scope.$text = $text;
    const $ctrl = this;

    $ctrl.isSubmiting = false;
    $ctrl.submitError = '';
    $ctrl.submitSuccess = false;
    
    $ctrl.ddiOptions = [];

    $ctrl.formData = {};
    $ctrl.dadosData = {};

    $ctrl.dadosErrors = {
        'nome': {},
        'telefone.ddi': {},
        'telefone.numero': {},
        'cpf': {},
        'nascimento': {}
    };

    $ctrl.validateDadosField = (name) => {

        $ctrl.dadosErrors[name] = {
            field: $scope.usuarioDadosForm[name].$invalid,
            hint: $scope.usuarioDadosForm[name].$invalid
        };
    };

    $ctrl.validateDadosFields = () => {

        Object.keys($ctrl.dadosErrors).forEach(name => {
            $ctrl.dadosErrors[name] = {
                field: $scope.usuarioDadosForm[name].$invalid,
                hint: $scope.usuarioDadosForm[name].$invalid
            }
        })
    };

    $ctrl.validate = {
        nome(value) {
            // Precisa conter ao menos 1 caractere após um ' ' (espaço).
            return value?.match(/.+ .+/)
        },
        cpf(value) {
            // Precisa conter um número de CPF Válido
            return value && $utils.validaCpf(value)
        }
    };

    $ctrl.getModifiedDadosData = () => {

        const modifiedData = {};

        Object.keys($ctrl.dadosData).forEach(name => {
            if ($scope.usuarioDadosForm[name].$dirty) {
                modifiedData[name] = $ctrl.dadosData[name];
            }
        })

        return modifiedData;
    };

    $ctrl.submitDadosForm = () => {

        if (!$scope.usuarioDadosForm.$valid) {
            $ctrl.validateDadosFields();
            return
        }

        $ctrl.formErrors = {};

        $ctrl.isSubmiting = true;
        $ctrl.submitError = '';
        $ctrl.submitSuccess = false;

        const dadosData = $ctrl.getModifiedDadosData();
        $fb.db.update(`/cad_usuarios/${$ctrl.baseUsuario.id}`, dadosData).then(() => {

            $scope.usuarioDadosForm.$setPristine();

            $toast.success($text.successfullUpdate);
            $scope.$emit('update-usuario');
        }).catch(e => {
            $ctrl.submitError = 'internal';

            throw e;
        }).finally(() => {
            $ctrl.isSubmiting = false;
        })
    };

    $ctrl.$onInit = () => {

        $fb.db.get('/sys_dominio/ddi').then(res => {
            if(!res.data){ console.log('Not Found: dominio/ddi'); return false; }
            $ctrl.ddiOptions = res.data.values;
        })

    };

    $ctrl.$onChanges = (changes) => {

        if (changes.baseUsuario && changes.baseUsuario.currentValue) {
            const baseUsuario = changes.baseUsuario.currentValue.data;

            $ctrl.dadosData = {
                'nome': baseUsuario.nome,
                'telefone.ddi': baseUsuario.telefone?.ddi?.toString() || '55',
                'telefone.numero': baseUsuario.telefone?.numero,
                'cpf': baseUsuario.cpf,
                'nascimento': baseUsuario.nascimento?.toDate()
            };

            $ctrl.fotoUrl = baseUsuario.fotoUrl ?? null;

            $ctrl.formData.email = baseUsuario.email;

            (baseUsuario.telefone&&baseUsuario.telefone.ddi) && $ctrl.ddiOptions.push({ ddi: baseUsuario.telefone.ddi.toString() });
        }
    };

    $ctrl.submitFoto = (event) => {
        if (!event.target.files[0].type.startsWith('image')) {
            return
        }

        $ctrl.fotoUrl = null;

        $utils.compressImage(event.target.files[0], 300, 300).then((res) => {
            return $fb.storage.upload(`/cad_usuarios/${$ctrl.idUsuario}/fotoPerfil`, res, undefined)
        }).then((url) => {
            $ctrl.fotoUrl = url;
            $ctrl.dadosData['fotoUrl'] = url;
            $scope.dadosData['fotoUrl'].$setDirty();
        }).catch(e=>{ console.log(e); })
    };
}])